import { useTranslation } from 'react-i18next';
import { canEmbed, chatEmbedUrl, SMART_BUILDER } from '../../ai-chat.ts';
import { AiChatFrame } from '../../components/AiChat.tsx';
import { PageHeader, Panel } from '../../components/ui.tsx';

/** Configuração › IA (ADR 0125): o chat do Smart Builder para mudar este sistema. */
export function AiSettingsPage() {
  const { t } = useTranslation();
  const link = SMART_BUILDER;
  const context = { page: '/settings/ai' };
  return (
    <div className="flex flex-col gap-4">
      <PageHeader title={t('aiChat.title')} description={t('aiChat.about')} />
      <Panel>
        {!link ? (
          <p className="text-sm text-muted">{t('aiChat.notLinked')}</p>
        ) : canEmbed(window.location.hostname, link) ? (
          <AiChatFrame link={link} context={context} className="h-[70vh] w-full rounded-md" />
        ) : (
          <a
            className="text-sm font-medium text-brand-text hover:underline"
            href={chatEmbedUrl(link, context)}
            target="_blank"
            rel="noreferrer"
          >
            {t('aiChat.newTab')}
          </a>
        )}
      </Panel>
    </div>
  );
}
